import type { SVGProps } from 'react';

export const CheckCircleSmallIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    className="fill-content-brand"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_2679_7360)">
      <circle cx="16" cy="16" r="16" />
      <path
        d="M9 17L13 21L23 11"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2679_7360">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
